{
	"title": "Δεν επιτρέπεται η πρόσβαση (403)",
	"description": "Δεν έχετε τα απαραίτητα δικαιώματα για πρόσβαση σε αυτήν τη σελίδα. Βεβαιωθείτε ότι είστε συνδεδεμένοι σε έναν λογαριασμό με τα κατάλληλα δικαιώματα. Η εκκαθάριση των δεδομένων του προγράμματος περιήγησής σας μπορεί επίσης να επιλύσει το πρόβλημα. Εάν εξακολουθείτε να χρειάζεστε πρόσβαση, επικοινωνήστε με τον διαχειριστή του συστήματος.",
	"secondaryButtonTitle": "Αποσύνδεση"
}
